export default function _isNativeFunction(fn){try{return-1!==Function.toString.call(fn).indexOf("[native code]")}catch(e){return"function"==typeof fn}}